// extracted by mini-css-extract-plugin
export default {"Column":"Spinner_Column__aRGZN","Button":"Spinner_Button__W4KFH"};